import { addressValidator } from './address';
import { areaCodesValidator } from './area-codes';
import { isUniqueValidator } from './is-unique';
import { notEmptyStringValidator } from './not-empty-string';
import { pharmacyIdsValidator } from './pharmacy-ids';
import { phoneNumberValidator } from './phone-number';
import { zipCodesValidator } from './zip-codes';

export const CustomValidators = {
  phoneNumber: phoneNumberValidator,
  address: addressValidator,
  isUnique: isUniqueValidator,
  notEmptyString: notEmptyStringValidator,
  areaCodes: areaCodesValidator,
  zipCodes: zipCodesValidator,
  pharmacyIds: pharmacyIdsValidator,
};
